module.exports = __webpack_public_path__ + "img/back.b9d08d10.png";